import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  ISocialConnectionStateProps,
  ISocialConnectionUIProps,
  SocialConnectionEditor,
} from '../components/SocialConnectionEditor'

export default connect(
  (state: ApplicationState, ownProps: ISocialConnectionUIProps) => {
    return createStructuredSelector<
      ApplicationState,
      ISocialConnectionStateProps
    >({})(state)
  },
)(SocialConnectionEditor)
